import React, { useMemo } from 'react';
import { Button } from '@myhealth-raccoon/components';
import moment, { Moment } from 'moment';
import { useBeforeUnload } from 'react-use';

import { useSelector } from 'src/store';
import { useAppointmentTypeSelector, useClinicSelector } from 'src/hooks/useAsyncSelector';
import { innerHtml } from 'src/utils/html';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { ContentContainer } from 'src/components/ContentContainer';
import { useBookingFlowStep } from 'src/hooks/useBookingFlowStep';
import { isAfterHours } from 'src/utils/appointmentTypes';

function isWeekend(date: Moment) {
    const dayOfWeek = date.day();
    return dayOfWeek === 0 || dayOfWeek === 6;
}

type Props = {
    nextPage: string;
}

export function ReviewAppointment({ nextPage }: Props) {
    useBookingFlowStep(4);
    // show dialog before closing/reloading
    useBeforeUnload();
    const { dateTime } = useSelector((state) => state.appointment);
    const { data: clinic, ...clinicRequest } = useClinicSelector();
    const { data: appointmentType, ...appointmentTypeRequest } = useAppointmentTypeSelector();

    const appointmentTime = useMemo(() => moment(dateTime), [dateTime]);

    return <>
        <ContentContainer className='flex-1 lg:flex-none'>
            <h1 className='text-2xl text-gray-900 font-semibold mb-8'>
                Almost there!<br />
                Your booking is not confirmed yet.
            </h1>

            {appointmentType && (!isAfterHours(appointmentType)
                ? clinic && clinic.confirmAppInfo &&
                <div className='prose-sm'
                    {...innerHtml((isWeekend(appointmentTime) && clinic.confirmAppHolidayInfo ? clinic.confirmAppHolidayInfo : clinic.confirmAppInfo)
                        .replace(/text-center/g, "text-left")
                        .replace(/<\/?(?:h1|h2|h3|h4|h5|h6|p)>\s*(<br\s?\/?>)/g, "")
                    )}
                />
                : <div className='prose-sm'>
                    <p>Your doctor will call you from a private number as close as possible to your appointment time. Please ensure you have access to a device with a camera, microphone, and a stable internet connection in case a video consultation is required.</p>
                    <p>Please allow up to 30-60 minutes from your booking time, as the doctor may be running late.</p>
                </div>
            )}
        </ContentContainer>
        <StickyBottomBar>
            <Button className='flex-1 text-center'
                to={nextPage}
                disabled={clinicRequest.isLoading || appointmentTypeRequest.isLoading}
            >Confirm booking</Button>
        </StickyBottomBar>
    </>
}